import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { KanbanViewCardI } from '../../models/kanban-view/kanban-order-viewI';
import { MatCheckbox } from '@angular/material/checkbox';
import * as moment from 'moment';

@Component({
  selector: 'anterasoftware-quote-view-card',
  templateUrl: './quote-view-card.component.html',
  styleUrls: ['./quote-view-card.component.scss']
})
export class QuoteViewCardComponent implements OnInit {

  @Output() public onCardDetailsChange: EventEmitter<any> = new EventEmitter();
  @Output() public editCardDetails: EventEmitter<any> = new EventEmitter();
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';
  dueColor: string = '';
  dueFontColor: string = '';
  @Input() public cardDetails: KanbanViewCardI = {
    select: false,
    id: '',
    orderNo: '',
    orderIdentity: '',
    orderDate: '',
    accountName: '',
    salesPerson: '',
    contactName: '',
    kanbanStatus:  "",
    inHandDateBy: ""
  };

  constructor() { }

  ngOnInit(): void {
    if (this.cardDetails.inHandDateBy && this.cardDetails.inHandDateBy !== '0000-00-00') {
      let cardDate = moment(this.cardDetails.inHandDateBy).endOf('day');
      let curDate = moment().endOf('day');
      let diff = cardDate.diff(curDate, 'hours');
      switch(true) {
        // red past due or due today
        case diff < 0:
          this.dueColor = 'red';
          this.dueFontColor = '#ffffff';
          break;
        //due today
        case diff == 0:
          this.dueColor = 'orange';
          this.dueFontColor = '#ffffff';
          break;
        // tomorrow
        case diff >= 24 && diff <= 24*2:
          this.dueColor = 'yellow';
          this.dueFontColor = '#000000';
          break;
        // this week
        case diff >= 24*2 && diff <= 24*7:
          this.dueColor = 'green';
          this.dueFontColor = '#ffffff';
          break;
        // next week
        case diff >= 24*7 && diff <= 24*14:
          this.dueColor = 'blue';
          this.dueFontColor = '#ffffff';
          break;
        // this month
        case diff >= 24*14 && diff <= 24*30:
          this.dueColor = 'black';
          this.dueFontColor = '#ffffff';
          break;
        default:
          this.dueColor = 'gray';
          this.dueFontColor = '#000000';
          break;              
      }
    }
  }

  public onCheckBoxSelected(event: MatCheckbox): void {
    this.onCardDetailsChange.emit(this.cardDetails);
  }

  public getDateFormat(date :any, includeTime = false, excludeTime = false, convert = false){
    if(date == null || date == '' || date == '0000-00-00 00:00:00' || date == '0000-00-00' || date == '0000-00-00' || (String(date).indexOf("0000") > -1 && String(date).indexOf("+0000") < 0 )){
        return '';
    }
    if(convert){
      if(includeTime){
    return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString);
    }
      }          
    }else{
      if(includeTime){
    return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(date).format(this.dateFormatString);
    }
      }      
    }
  }

  public editCard(lead: any) {
    this.editCardDetails.emit(lead);
  }

}
